module.exports = __webpack_public_path__ + "img/object_utilgn.e75614bb.svg";